import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared';

type RdProjectBusinessComponentIds = {
  businessComponentId: string;
  businessPurposeId: string;
};

export const useRdProjectBusinessComponentIds = (): RdProjectBusinessComponentIds => ({
  businessComponentId: useAnalyticId(AnalyticIdentifier.ENTERPRISE_PROJECT_BUSINESS_COMPONENT),
  businessPurposeId: useAnalyticId(AnalyticIdentifier.ENTERPRISE_PROJECT_BUSINESS_PURPOSE),
});
